<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Recorridos</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Facturación</span>
      <span> /</span>
      <span>Recorridos</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6;">
      <div></div>
      <button
        type="button"
        mdbBtn
        color="info"
        (click)="agregarRecorrido.show()"
        size="sm"
        mdbWavesEffect
      >
        Agregar
      </button>
    </div>
    <div class="row filtros-body">
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <input
            value=""
            type="text"
            id="codProduct"
            class="form-control"
            placeholder="000"
            required
            #codProduct
          />
          <label for="codProduct">Nro. de recorrido</label>
        </div>
      </div>
      <div class="col" style="max-width: 100px;">
        <button
          mdbBtn
          type="button"
          class="btn-cuadrado"
          color="secondary"
          mdbWavesEffect
          (click)="seleccionarRecorrido.show()"
        >
          <mdb-icon fas icon="search"></mdb-icon>
        </button>
      </div>

      <div class="col dato" style="max-width: 150px;">
        <Strong class="title">Fecha</Strong>
        <span class="value">dd/mm/aaaa</span>
      </div>
      <div class="col dato" style="max-width: 150px;">
        <Strong class="title">Patente</Strong>
        <span class="value">XXXX-99</span>
      </div>
      <div class="col dato" style="max-width: 250px;">
        <Strong class="title">Chófer</Strong>
        <span class="value">Juan Pérez González</span>
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div
    class="card-footer text-muted filtros-footer"
    style="border-top: 1px solid #dee2e6;"
  >
    <div></div>
    <button
      mdbBtn
      type="button"
      color="secondary"
      mdbWavesEffect
      (click)="verDocumentos.show()"
    >
      Ver documentos
    </button>
  </div>
</div>

<!-- Filtros -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-body">
      <div class="col dato" style="max-width: 300px;">
        <div class="md-form m-0">
          <mdb-select
            label="Comuna"
            [options]="optionsComuna"
            placeholder="Seleccionar Comuna"
            [filterEnabled]="true"
          ></mdb-select>
        </div>
      </div>
      <div class="col dato" style="max-width: 300px;">
        <div class="md-form m-0">
          <mdb-select
            label="Ruta"
            [options]="optionsRuta"
            placeholder="Seleccionar Ruta"
            [filterEnabled]="true"
          ></mdb-select>
        </div>
      </div>
      <div class="col dato" style="max-width: 300px;">
        <div class="md-form m-0">
          <mdb-select
            label="Vendedor"
            [options]="optionsVendedor"
            placeholder="Seleccionar Vendedor"
            [filterEnabled]="true"
          ></mdb-select>
        </div>
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div
    class="card-footer text-muted filtros-footer"
    style="border-top: 1px solid #dee2e6;"
  >
    <div></div>
    <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect>
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>
  </div>
</div>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col"><mdb-checkbox></mdb-checkbox></th>
            <th scope="col">Fecha</th>
            <th scope="col">T.D.</th>
            <th scope="col">Nro. Doc.</th>
            <th scope="col">Ruta</th>
            <th scope="col">Cliente</th>
            <th scope="col">Dirección</th>
            <th scope="col">Comuna</th>
            <th scope="col">Vendedor</th>
            <th scope="col">Monto Neto</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><mdb-checkbox></mdb-checkbox></td>
            <td>dd/mm/aaaa</td>
            <td>FE</td>
            <td>9999999</td>
            <td>[051] FARFANA</td>
            <td>Juan Pérez</td>
            <td>Santa Victoria 41</td>
            <td>Santiago</td>
            <td>[001] Juan Pérez</td>
            <td>$ 10.000</td>
            <td>
              <button
                mdbBtn
                type="button"
                color="info"
                mdbWavesEffect
                class="btn"
                size="sm"
                (click)="detalleDocumento.show()"
              >
                Detalle
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn">
      Asignar a recorrido
    </button>
  </div>
</div>

<!-- MODAL Agregar recorrido -->
<div
  mdbModal
  #agregarRecorrido="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Agregar recorrido
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="agregarRecorrido.hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div class="md-form m-0">
              <mdb-date-picker
                [inline]="true"
                name="fechaRecorrido"
                [placeholder]="'Fecha'"
                required
              ></mdb-date-picker>
            </div>
          </div>
          <div class="col">
            <div class="md-form m-0">
              <mdb-select
                label="Patente"
                [options]="optionsPatente"
                placeholder="Seleccionar Patente"
                [filterEnabled]="true"
              ></mdb-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col dato">
            <table
              class="table table-striped table-hover table-sm align-middle"
            >
              <thead class="grey lighten-2">
                <tr>
                  <th scope="col" class="text-center">Peso</th>
                  <th scope="col" class="text-center">Volumen</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center">0.00</td>
                  <td class="text-center">0.00</td>
                </tr>
              </tbody>
            </table>
            <div class="md-form">
              <!-- Material inline 1 -->
              <mdb-checkbox [inline]="true">Peso</mdb-checkbox>

              <!-- Material inline 2 -->
              <mdb-checkbox [inline]="true">Volumen</mdb-checkbox>

              <!-- Material inline 3 -->
              <mdb-checkbox [inline]="true">monto</mdb-checkbox>
            </div>
            <div class="md-form mb-0">
              <mdb-select
                label="Chófer"
                [options]="optionsChofer"
                placeholder="Seleccionar Chófer"
                [filterEnabled]="true"
              ></mdb-select>
            </div>
            <table
              class="table table-striped table-hover table-sm align-middle"
            >
              <thead class="grey lighten-2">
                <tr>
                  <th scope="col" class="text-center">RUT</th>
                  <th scope="col" class="text-center">Dirección</th>
                  <th scope="col" class="text-center">Teléfono</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center">XX.XXX.XXX-X</td>
                  <td class="text-center">XXXXXXXXXX 9999 XXXX XXXXX</td>
                  <td class="text-center">9999999999</td>
                </tr>
              </tbody>
            </table>
            <div class="md-form">
              <input
                value=""
                type="text"
                id="monto"
                class="form-control"
                placeholder="000"
                required
                #monto
              />
              <label for="monto">Monto</label>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button
          type="button"
          class="btn btn-default waves-light"
          data-dismiss="modal"
          (click)="agregarRecorrido.hide()"
          mdbWavesEffect
        >
          Cerrar
        </button>
        <button
          type="button"
          class="btn btn-success waves-light"
          mdbWavesEffect
          (click)="agregarRecorrido.hide()"
        >
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL Detalle documento -->
<div
  mdbModal
  #detalleDocumento="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Docuemnto Nro. 9999999
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="detalleDocumento.hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col" class="text-center">Cod. Prod.</th>
                <th scope="col" class="text-center">Descripción</th>
                <th scope="col" class="text-center">Und. Medida</th>
                <th scope="col" class="text-center">Cantidad</th>
                <th scope="col" class="text-center">Rec.</th>
                <th scope="col" class="text-center">Desc.</th>
                <th scope="col" class="text-center">Monto</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Producto 1</td>
                <td>Caja</td>
                <td>5</td>
                <td>0</td>
                <td>0</td>
                <td>$ 10.000</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Producto 1</td>
                <td>Caja</td>
                <td>5</td>
                <td>0</td>
                <td>0</td>
                <td>$ 10.000</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Producto 1</td>
                <td>Caja</td>
                <td>5</td>
                <td>0</td>
                <td>0</td>
                <td>$ 10.000</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button
          type="button"
          class="btn btn-default waves-light"
          data-dismiss="modal"
          (click)="detalleDocumento.hide()"
          mdbWavesEffect
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL seleccionarRecorrido-->
<div
  mdbModal
  #seleccionarRecorrido="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Seleccionar recorrido
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="seleccionarRecorrido.hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div class="md-form m-0">
              <input
                value=""
                type="text"
                id="nombreProduct"
                class="form-control"
                placeholder="Nombre o RUT del cliente"
                required
                #nombreProduct
              />
              <label for="nombreProduct">Nro. Recorrido</label>
            </div>
          </div>
          <div class="col">
            <div class="md-form m-0">
              <mdb-date-picker
                [inline]="true"
                name="fechaRecorrido"
                [placeholder]="'Fecha'"
                required
              ></mdb-date-picker>
            </div>
          </div>
          <div class="col" style="width: 50px;">
            <button
              mdbBtn
              type="button"
              class="btn-cuadrado"
              color="secondary"
              mdbWavesEffect
            >
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
          </div>
        </div>
        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col" class="text-center">Nro. Rec.</th>
              <th scope="col" class="text-center">Patente</th>
              <th scope="col" class="text-center">Chófer</th>
              <th scope="col" class="text-center">Monto a cobrar</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1212</td>
              <td>HHDD99</td>
              <td>Juan Perez</td>
              <td>$ 10.000</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                  (click)="seleccionarRecorrido.hide()"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>1212</td>
              <td>HHDD99</td>
              <td>Juan Perez</td>
              <td>$ 10.000</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                  (click)="seleccionarRecorrido.hide()"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>1212</td>
              <td>HHDD99</td>
              <td>Juan Perez</td>
              <td>$ 10.000</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                  (click)="seleccionarRecorrido.hide()"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- MODAL verDocumentos -->
<div
  mdbModal
  #verDocumentos="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-fluid" style="max-width: 80%;" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Documentos de Nro. Rec. 999999
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="verDocumentos.hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col"><mdb-checkbox></mdb-checkbox></th>
                <th scope="col">Fecha</th>
                <th scope="col">Nro. Dcto.</th>
                <th scope="col">Tipo</th>
                <th scope="col">Cliente</th>
                <th scope="col">Dirección</th>
                <th scope="col">Comuna</th>
                <th scope="col">Vendedor</th>
                <th scope="col">Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><mdb-checkbox [checked]="true"></mdb-checkbox></td>
                <td>dd/mm/aaaa</td>
                <td>99999999</td>
                <td>FE</td>
                <td>Juan Perez</td>
                <td>Santa Victoria 41</td>
                <td>Santiago</td>
                <td>[051] Juan Perez</td>
                <td>$ 10.000</td>
                <td>
                  <button
                    mdbBtn
                    type="button"
                    color="info"
                    mdbWavesEffect
                    class="btn"
                    size="sm"
                    (click)="detalleDocRec.show()"
                  >
                    Detalle
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button
          type="button"
          class="btn btn-warning waves-light"
          data-dismiss="modal"
          mdbWavesEffect
        >
          Remover recorridos (2)
        </button>
        <button
          type="button"
          class="btn btn-default waves-light"
          data-dismiss="modal"
          (click)="verDocumentos.hide()"
          mdbWavesEffect
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL Detalle documento -->
<div
  mdbModal
  #detalleDocRec="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Docuemnto Nro. 9999999
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="detalleDocRec.hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col" class="text-center">Cod. Prod.</th>
                <th scope="col" class="text-center">Descripción</th>
                <th scope="col" class="text-center">Cantidad</th>
                <th scope="col" class="text-center">Und. de Venta</th>
                <th scope="col" class="text-center">Precio</th>
                <th scope="col" class="text-center">Desc.</th>
                <th scope="col" class="text-center">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>999</td>
                <td>Cassata Vainilla 2Lt.</td>
                <td>10</td>
                <td>Caja</td>
                <td>$ 40.000</td>
                <td>$ 10.000</td>
                <td>$ 30.000</td>
              </tr>
              <tr>
                <td>999</td>
                <td>Cassata Vainilla 2Lt.</td>
                <td>10</td>
                <td>Caja</td>
                <td>$ 40.000</td>
                <td>$ 10.000</td>
                <td>$ 30.000</td>
              </tr>
              <tr>
                <td>999</td>
                <td>Cassata Vainilla 2Lt.</td>
                <td>10</td>
                <td>Caja</td>
                <td>$ 40.000</td>
                <td>$ 10.000</td>
                <td>$ 30.000</td>
              </tr>
              <tr>
                <td>999</td>
                <td>Cassata Vainilla 2Lt.</td>
                <td>10</td>
                <td>Caja</td>
                <td>$ 40.000</td>
                <td>$ 10.000</td>
                <td>$ 30.000</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button
          type="button"
          class="btn btn-default waves-light"
          data-dismiss="modal"
          (click)="detalleDocRec.hide()"
          mdbWavesEffect
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>
